import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-three",
)({
  server: {
    handlers: {
      GET: async () => {
        return new Response(null, {
          status: 301,
          headers: {
            Location:
              "/dr-fitzer-dissects-the-news/weight-regain-after-wegovy-zepbound-treatment-part-3",
          },
        });
      },
    },
  },
  component: () => null,
});
